import { resolveProductImageBox, type ProductImageElement } from '../api/types';

/** Every product-box edit writes the FULL explicit box and drops `scale`.
 *  For the same numbers the compositor produces the same box (w/h replace the
 *  scaled dims with equal values; the re-centre term is zero), so converting a
 *  legacy scale-only config on its first edit is byte-identical — only the
 *  config_hash moves, as for any edit. */
export function productBoxPatch(
  el: ProductImageElement | undefined,
  patch: Partial<{ x: number; y: number; w: number; h: number }>,
  canvasW?: number,
): Record<string, unknown> {
  const box = resolveProductImageBox(el, canvasW);
  return { x: box.x, y: box.y, w: box.w, h: box.h, ...patch, scale: undefined };
}

export function resetBoxPatch(): Record<string, unknown> {
  return { x: undefined, y: undefined, w: undefined, h: undefined, scale: undefined, trim: undefined };
}
